export default __webpack_public_path__ + "static/media/7df9a04bf0e21dc6.1130f490b395c7cc4450e3176cb549c1.svg";